/**
 * Renders a copy string where segments wrapped in <em>…</em> become
 * the italic serif accent. Plain text is rendered as text nodes, so
 * no raw HTML ever touches the DOM.
 */
export default function Emphasis({ text }) {
  const parts = text.split(/(<em>.*?<\/em>)/g).filter(Boolean);
  return parts.map((part, i) => {
    const m = part.match(/^<em>(.*?)<\/em>$/);
    return m ? <em key={i}>{m[1]}</em> : <span key={i}>{part}</span>;
  });
}
